/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


(function () {
  const CLICK_CLASS = 'atc-click';
  const SELECTOR = '.atc-animated';

  function addClickAnim(btn) {
    if (!btn) return;
    if (btn.hasAttribute('disabled')) return;
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    btn.classList.remove(CLICK_CLASS);
    void btn.offsetWidth; // força reflow para reiniciar animação
    btn.classList.add(CLICK_CLASS);

    clearTimeout(btn.__atcClickTimer);
    btn.__atcClickTimer = setTimeout(() => {
      btn.classList.remove(CLICK_CLASS);
    }, 550);
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(SELECTOR);
      if (!btn) return;
      addClickAnim(btn);
    },
    true
  );
})();





// Broadcast: Guardar último submenu aberto
(function(){
  var KEY = 'bcast_menu';
  var path = [];
  var drawer = document.querySelector('header-drawer[data-drawer*="mobile-menu"]');

  if(!drawer) return;

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-menu-key]');
    if(btn){
      var id = btn.getAttribute('data-menu-key');
      var idx = path.indexOf(id);
      if(idx !== -1) path = path.slice(0, idx);
      path.push(id);
      sessionStorage.setItem(KEY, JSON.stringify(path));
    }
    if(e.target.closest('[data-sliderule-close]')){
      path.pop();
      sessionStorage.setItem(KEY, JSON.stringify(path));
    }
    if(e.target.closest('[data-drawer-close]') ||
       e.target.closest('[data-drawer-underlay]')){
      path = [];
      sessionStorage.removeItem(KEY);
    }
  });

  new MutationObserver(function(){
    var isOpen = drawer.classList.contains('is-open');
    if(!isOpen) return;

    var saved = sessionStorage.getItem(KEY);
    if(!saved) return;

    var pathToRestore = JSON.parse(saved);
    if(!pathToRestore || !pathToRestore.length) return;

    // Desativa animações
    var style = document.createElement('style');
    style.id = 'no-anim-restore';
    style.innerHTML = 'mobile-sliderule *, .sliderule__panel { transition: none !important; animation-duration: 0ms !important; }';
    document.head.appendChild(style);

    // Clica em todos instantaneamente
    pathToRestore.forEach(function(id){
      var trigger = drawer.querySelector('[data-menu-key="'+id+'"]');
      if(trigger) trigger.click();
    });

    // Reativa animações
    setTimeout(function(){
      var s = document.getElementById('no-anim-restore');
      if(s) s.remove();
    }, 50);

  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

})();



/* ================================================
   PRODUTO - Troca a posição do price e compare-at-price
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-price-wrapper]');
  if (!wrapper) return;

  const sale = wrapper.querySelector('[data-product-price]');
  const strike = wrapper.querySelector('[data-compare-price]');

  if (sale && strike) {
    wrapper.insertBefore(strike, wrapper.firstChild);
  }
});

/* ================================================
   PRODUTO - Move badge de desconto para dentro do wrapper de preços
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const badge = document.querySelector('[data-price-off-badge]');
  const wrapper = document.querySelector('[data-price-wrapper]');

  if (badge && wrapper) {
    wrapper.appendChild(badge);
  }
});



/* ================================================
   PREÇO EM CASCATA — SÓ CARRINHO (overlay não destrutivo)
   ------------------------------------------------
   Versão reduzida: o widget da product page e os badges/
   preços mínimos dos cards da coleção foram REMOVIDOS.
   Fica apenas a parte do CARRINHO: os preços de linha
   passam a refletir o escalão por quantidade + cupão.

   ROLLBACK IMEDIATO:
   - AV_CASCATA.ativo = false  → tudo volta ao original
   - Apagar deste bloco até ao fim do ficheiro tem o mesmo efeito
   ================================================ */

var AV_CASCATA = {
  ativo: true,               // <<< KILL-SWITCH

  corPreco: '#FF0000',       // vermelho dos preços promocionais (o teu)
  debug: true,               // logs na consola p/ diagnóstico (pôr false depois)

  descontoQtd: 25,           // % desconto 4+ artigos
  descontoCupao: 10,         // % desconto do cupão
  cupao: '10ALMA',
  qtdMinima: 4,

  precosNoCarrinho: true,    // preços de linha do carrinho refletem escalão + cupão

  // Escalões automáticos (iguais aos do Shopify admin, do maior para o menor)
  descontosPorQtd: [
    { min: 4, pct: 25 },
    { min: 3, pct: 20 },
    { min: 2, pct: 15 }
  ]
};

(function () {
  if (!AV_CASCATA.ativo) return;

  /* ---------- estilos injetados pelo próprio JS ----------
     Só o necessário para o carrinho. Remover o JS remove
     também os estilos → rollback total. */

  function injetarEstilos() {
    if (document.getElementById('av-cascata-css')) return;
    var css =
      '.av-escondido{display:none!important}' +
      '.av-cart-preco{color:' + AV_CASCATA.corPreco + ' !important;font-weight:700}';
    var el = document.createElement('style');
    el.id = 'av-cascata-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* ---------- helpers ---------- */

  function parseEuro(t) {
    if (!t) return null;
    var limpo = t.replace(/[^\d,\.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
    var n = parseFloat(limpo);
    return isNaN(n) ? null : Math.round(n * 100); // cêntimos
  }

  /* ---------- carrinho: preços de linha com escalão dinâmico ----------
     O preço de linha do tema já inclui o cupão (10ALMA); aqui aplicamos
     por cima o escalão automático conforme a quantidade TOTAL do carrinho.
     A secção "Descontos" e o TOTAL em baixo ficam intocados (Shopify). */

  function nivelDesconto(qtdTotal) {
    var n = AV_CASCATA.descontosPorQtd;
    for (var i = 0; i < n.length; i++) if (qtdTotal >= n[i].min) return n[i].pct;
    return 0;
  }

  // querySelectorAll que atravessa shadow DOM aberto (apps como UpCart)
  function qsaDeep(sel) {
    var out = [];
    function walk(root) {
      root.querySelectorAll(sel).forEach(function (e) { out.push(e); });
      root.querySelectorAll('*').forEach(function (e) {
        if (e.shadowRoot) walk(e.shadowRoot);
      });
    }
    walk(document);
    return out;
  }

  function carrinho() {
    if (!AV_CASCATA.precosNoCarrinho) return;

    // Fonte oficial: /cart.js (quantidades e preços de linha, já com cupões de linha)
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      var pctNivel = nivelDesconto(cart.item_count);
      if (AV_CASCATA.debug) console.log('[av-cascata] carrinho:', cart.item_count, 'artigos, escalão', pctNivel + '%');

      var linhasVistas = [];

      cart.items.forEach(function (item) {
        // TODAS as ocorrências do link (drawer do tema escondido + UpCart visível)
        var links = qsaDeep('a[href*="variant=' + item.variant_id + '"]');
        if (!links.length) { if (AV_CASCATA.debug) console.log('[av-cascata] sem link p/ variante', item.variant_id); return; }

        links.forEach(function (link) {
          var row = link.closest('li, tr, [class*="item" i]') || link.parentElement;
          var sobe = 0;
          while (row && sobe < 4 && !/\d,\d\d/.test(row.textContent)) { row = row.parentElement; sobe++; }
          if (!row || linhasVistas.indexOf(row) !== -1) return;
          linhasVistas.push(row);

          // guarda: só linhas de carrinho (controlo de quantidade ou labels da app)
          var temQtd = row.querySelector('input[type="number"], [name*="updates"], [class*="quantit" i], [class*="qty" i], [aria-label*="quantit" i], button[name="plus"], button[name="minus"]') ||
                       /quantity|quantidade|qty/i.test(row.textContent);
          if (!temQtd) return;

          // alvo: total da linha (final_line_price) ou, em alternativa, preço unitário
          var achado = procurarPreco(row, item.final_line_price) ||
                       procurarPreco(row, item.final_price);
          if (!achado) {
            if (AV_CASCATA.debug) console.log('[av-cascata] preço não encontrado p/', item.variant_id, item.final_line_price, '/', item.final_price, row);
            return;
          }

          var span = achado.el.previousElementSibling;
          if (!span || !span.classList || !span.classList.contains('av-cart-preco')) {
            span = document.createElement('span');
            span.className = 'av-cart-preco';
            // formato/estilo iguais ao preço original da app
            var cs = getComputedStyle(achado.el);
            span.style.fontSize = cs.fontSize;
            span.style.fontWeight = cs.fontWeight;
            span.style.fontFamily = cs.fontFamily;
            span.style.setProperty('color', AV_CASCATA.corPreco, 'important');
            achado.el.before(span);
            achado.el.classList.add('av-escondido');
            // inline: única forma de esconder dentro de shadow DOM (CSS do head não chega lá)
            achado.el.style.setProperty('display', 'none', 'important');
          }
          var cent = Math.round(achado.valor * (100 - pctNivel) / 100);
          var num = (cent / 100).toFixed(2).replace('.', ',');
          // € antes ou depois, conforme o original ("€39,95" vs "39,95 €")
          var novo = /€\s*\d/.test(achado.el.textContent || '') ? '€' + num : num + '\u00A0€';
          if (span.textContent !== novo) span.textContent = novo; // evita loop do observer
        });
      });
    }).catch(function (e) { if (AV_CASCATA.debug) console.warn('[av-cascata] /cart.js falhou', e); });
  }

  // Procura em row o valor (cêntimos) num elemento folha ou nó de texto solto
  function procurarPreco(row, valor) {
    if (!valor) return null;
    var todos = row.querySelectorAll('*');
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      if (el.closest('s') || el.closest('del')) continue;
      if (el.classList.contains('av-cart-preco')) continue;
      if (!el.firstElementChild && parseEuro(el.textContent) === valor) return { el: el, valor: valor };
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && parseEuro(n.nodeValue) === valor) {
          var wrap = document.createElement('span');
          wrap.className = 'av-cart-original';
          n.parentNode.insertBefore(wrap, n);
          wrap.appendChild(n);
          return { el: wrap, valor: valor };
        }
      }
    }
    return null;
  }

  /* ---------- init + reagir a AJAX do carrinho ---------- */

  function correr() {
    try { injetarEstilos(); carrinho(); }
    catch (e) { console.warn('[av-cascata]', e); } // nunca partir a página
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }

  var avTimer;
  new MutationObserver(function () {
    clearTimeout(avTimer);
    avTimer = setTimeout(correr, 200);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  // polling de segurança: apps de carrinho em shadow DOM (UpCart) não
  // disparam o MutationObserver do body
  setInterval(correr, 1500);
})();


/* ================================================
   POPOVER "PREÇO MÍNIMO" NO CARRINHO  (extensão isolada)
   ------------------------------------------------
   Não altera nada do bloco AV_CASCATA acima — só lê
   AV_CASCATA.cupao / .qtdMinima / .descontoQtd / .descontoCupao
   para não duplicar configuração, e localiza o preço que o
   bloco anterior já calculou (.av-cart-preco) para colocar o
   ícone "i" ao lado, no início do bloco de preços da linha.

   O QUE FAZ:
   - Vai buscar o /cart.js (quantidade total + cupões aplicados)
   - Para cada linha do carrinho, calcula o preço mínimo PRÓPRIO
     desse artigo (cupão + escalão sobre o preço normal dele)
   - Mostra um ícone "i" (a pulsar até ao 1.º clique) com um
     popover a explicar quantos artigos faltam e o estado do cupão
   - Regista cada clique no GA4 (evento av_tooltip_click)

   ROLLBACK IMEDIATO:
   Apaga tudo a partir desta linha até ao fim do ficheiro.
   ================================================ */

(function () {
  if (typeof AV_CASCATA === 'undefined' || !AV_CASCATA.ativo) return;

  var TEXTOS = {
    faltamSemCupao: 'O preço mínimo deste produto é <strong>{minimo}</strong>. Para usufruir deste preço adicione mais {faltam} artigo{plural} e aplique o cupão <strong>{cupao}</strong>.',
    faltamComCupao: 'O preço mínimo deste produto é <strong>{minimo}</strong>. Para usufruir deste preço adicione mais {faltam} artigo{plural}.',
    atingidoSemCupao: 'O preço mínimo deste produto é <strong>{minimo}</strong>. Já tem artigos suficientes. Aplique o cupão <strong>{cupao}</strong> para o desbloquear.',
    atingidoComCupao: 'Conseguiu! <strong>{minimo}</strong> é o preço mais baixo possível para este produto.'
  };

  /* ---------- helpers (duplicados de propósito — zero dependência do bloco anterior) ---------- */

  function fmtEuro(c) {
    return (c / 100).toFixed(2).replace('.', ',') + '\u00A0€';
  }

  // Preço mínimo pela MESMA ordem que o carrinho aplica na prática:
  // 1.º o cupão (o Shopify aplica-o ao preço de linha), 2.º o escalão de
  // quantidade, com arredondamento em cada passo. A ordem inversa dava
  // diferenças de 1 cêntimo (ex.: 30,34 no popover vs 30,35 no carrinho).
  function precoMinimo(c) {
    var aposCupao = Math.round(c * (100 - AV_CASCATA.descontoCupao) / 100);
    return Math.round(aposCupao * (100 - AV_CASCATA.descontoQtd) / 100);
  }

  function qsaDeep(sel) {
    var out = [];
    function walk(root) {
      root.querySelectorAll(sel).forEach(function (e) { out.push(e); });
      root.querySelectorAll('*').forEach(function (e) {
        if (e.shadowRoot) walk(e.shadowRoot);
      });
    }
    walk(document);
    return out;
  }

  function textoPopover(qtdTotal, minimoCents, cupaoAplicado) {
    var faltam = Math.max(0, AV_CASCATA.qtdMinima - qtdTotal);
    var minimoFmt = fmtEuro(minimoCents);

    if (faltam === 0) {
      var tplAtingido = cupaoAplicado ? TEXTOS.atingidoComCupao : TEXTOS.atingidoSemCupao;
      return tplAtingido.replace('{minimo}', minimoFmt).replace('{cupao}', AV_CASCATA.cupao);
    }

    var tplFaltam = cupaoAplicado ? TEXTOS.faltamComCupao : TEXTOS.faltamSemCupao;
    return tplFaltam
      .replace('{minimo}', minimoFmt)
      .replace('{faltam}', faltam)
      .replace('{plural}', faltam === 1 ? '' : 's')
      .replace('{cupao}', AV_CASCATA.cupao);
  }

  /* ---------- estilos aplicados DIRETAMENTE nos elementos (inline) ----------
     Propositadamente NÃO uso uma folha de estilos injetada aqui: no teu site
     essa abordagem não estava a "pegar" no ícone/popover (ficava quadrado e
     sempre aberto). Aplicar tudo inline, elemento a elemento, torna isto
     imune a qualquer CSS do tema — é a mesma técnica que já usas para a
     cor vermelha do preço (style.setProperty). */

  function estilizarWrap(wrap) {
    wrap.style.position = 'relative';
    wrap.style.display = 'inline-flex';
    wrap.style.alignItems = 'center';
    wrap.style.verticalAlign = 'middle';
    wrap.style.marginRight = '6px';
  }

  function estilizarIcone(btn) {
    btn.style.setProperty('width', '16px', 'important');
    btn.style.setProperty('height', '16px', 'important');
    btn.style.setProperty('min-width', '16px', 'important');
    btn.style.setProperty('border-radius', '50%', 'important');
    btn.style.setProperty('border', '1.5px solid #9a9a9a', 'important');
    btn.style.setProperty('color', '#6b6b6b', 'important');
    btn.style.setProperty('background', '#fff', 'important');
    btn.style.setProperty('font-size', '10px', 'important');
    btn.style.setProperty('font-weight', '700', 'important');
    btn.style.setProperty('font-style', 'italic', 'important');
    btn.style.setProperty('font-family', 'Georgia, serif', 'important');
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    btn.style.setProperty('padding', '0', 'important');
    btn.style.setProperty('margin', '0', 'important');
    btn.style.setProperty('line-height', '1', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('appearance', 'none', 'important');
    btn.style.setProperty('-webkit-appearance', 'none', 'important');
    btn.style.setProperty('outline', 'none', 'important');
    btn.style.setProperty('flex', '0 0 auto', 'important');
  }

  function estilizarTooltip(tip) {
    tip.style.setProperty('display', 'none', 'important'); // fechado por default
    tip.style.setProperty('position', 'absolute', 'important');
    tip.style.setProperty('top', 'calc(100% + 8px)', 'important');
    tip.style.setProperty('left', '0', 'important');
    tip.style.setProperty('z-index', '9999', 'important');
    tip.style.setProperty('width', '230px', 'important');
    tip.style.setProperty('max-width', '75vw', 'important');
    tip.style.setProperty('background', '#1a1a1a', 'important');
    tip.style.setProperty('color', '#fff', 'important');
    tip.style.setProperty('font-size', '12px', 'important');
    tip.style.setProperty('font-weight', '400', 'important');
    tip.style.setProperty('font-style', 'normal', 'important');
    tip.style.setProperty('font-family', '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif', 'important');
    tip.style.setProperty('line-height', '1.45', 'important');
    tip.style.setProperty('padding', '10px 12px', 'important');
    tip.style.setProperty('border-radius', '7px', 'important');
    tip.style.setProperty('box-shadow', '0 6px 18px rgba(0,0,0,.22)', 'important');
    tip.style.setProperty('white-space', 'normal', 'important');
    tip.style.setProperty('text-align', 'left', 'important');
    tip.style.setProperty('margin', '0', 'important');
  }

  /* ---------- ícone + popover ----------
     O clique é ligado DIRETAMENTE a cada botão (não delegado no document):
     o carrinho pode viver dentro de shadow DOM e/ou parar a propagação dos
     cliques, o que impedia o listener global de os receber — era por isso
     que "não fazia nada". O listener global fica só para fechar ao clicar
     fora (em fase de captura + composedPath, que atravessa shadow DOM). */

  var tooltipsCriados = []; // registo de todos os popovers (querySelectorAll não entra no shadow DOM)

  function fecharTodos() {
    tooltipsCriados.forEach(function (t) {
      t.style.setProperty('display', 'none', 'important');
      t.style.transform = '';
    });
  }

  // Garante que o popover nunca sai do ecrã, seja qual for a posição do ícone
  function posicionar(tip) {
    tip.style.transform = '';
    var rect = tip.getBoundingClientRect();
    var margem = 10;
    var direita = rect.right - (window.innerWidth - margem);
    var esquerda = margem - rect.left;
    if (direita > 0) tip.style.transform = 'translateX(-' + direita + 'px)';
    else if (esquerda > 0) tip.style.transform = 'translateX(' + esquerda + 'px)';
  }

  function ligarBotao(botao, tooltip) {
    // Animação de pulso suave (Web Animations API: funciona dentro de shadow
    // DOM, onde @keyframes do <head> não chegam). Para na 1.ª interação e
    // não volta nessa sessão (sessionStorage).
    var jaInteragiu = false;
    try { jaInteragiu = sessionStorage.getItem('av_tooltip_clicado') === '1'; } catch (err) {}

    var anim = null;
    if (!jaInteragiu && botao.animate) {
      anim = botao.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.25)' },
          { transform: 'scale(1)' }
        ],
        { duration: 1600, iterations: Infinity, easing: 'ease-in-out' }
      );
    }

    botao.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // parar a animação (neste e nos restantes ícones da sessão)
      if (anim) { anim.cancel(); anim = null; }
      try { sessionStorage.setItem('av_tooltip_clicado', '1'); } catch (err) {}
      pararTodasAnimacoes();

      registarClique();

      var jaAberto = tooltip.style.display === 'block';
      fecharTodos();
      if (!jaAberto) {
        tooltip.style.setProperty('display', 'block', 'important');
        posicionar(tooltip);
      }
    });

    if (anim) animacoesAtivas.push(anim);
  }

  var animacoesAtivas = [];
  function pararTodasAnimacoes() {
    animacoesAtivas.forEach(function (a) { try { a.cancel(); } catch (err) {} });
    animacoesAtivas = [];
  }

  /* ---------- medição de cliques (para o teu caso de estudo) ----------
     1) Envia um evento "av_tooltip_click" para o Google Analytics 4 (gtag)
        ou para o dataLayer (GTM), se existirem no site. É aí que consegues
        ver os totais agregados de todos os clientes:
        GA4 → Relatórios → Interação → Eventos → av_tooltip_click
     2) Fallback local: guarda um contador em localStorage
        (chave "av_tooltip_cliques"). Este só conta o browser atual — serve
        para testares. Para veres: consola → localStorage.getItem('av_tooltip_cliques') */

  function registarClique() {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'av_tooltip_click', { event_category: 'preco_minimo', event_label: location.pathname });
      } else if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'av_tooltip_click', pagina: location.pathname });
      }
    } catch (err) {}
    try {
      var n = parseInt(localStorage.getItem('av_tooltip_cliques') || '0', 10) + 1;
      localStorage.setItem('av_tooltip_cliques', String(n));
      if (AV_CASCATA.debug) console.log('[av-tooltip-cart] cliques (este browser):', n);
    } catch (err) {}
  }

  function initListener() {
    if (window.__avTooltipCartInit) return;
    window.__avTooltipCartInit = true;

    // Fechar ao clicar fora: fase de captura + composedPath para funcionar
    // mesmo quando o clique acontece dentro de shadow DOM ou é travado depois
    document.addEventListener('click', function (e) {
      var caminho = e.composedPath ? e.composedPath() : [e.target];
      for (var i = 0; i < caminho.length; i++) {
        var el = caminho[i];
        if (el && el.classList && (el.classList.contains('av-info-icon') || el.classList.contains('av-tooltip'))) {
          return; // clique no ícone ou dentro do popover: não fechar aqui
        }
      }
      fecharTodos();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fecharTodos();
    });
  }

  /* ---------- localizar cada linha e colocar o ícone no INÍCIO do preço ---------- */

  function processarCarrinho() {
    if (!AV_CASCATA.precosNoCarrinho) return;

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;

      // cart.discount_codes: [{code, applicable}] — cupões atualmente aplicados
      var cupaoAplicado = !!(cart.discount_codes || []).some(function (d) {
        return d.code && d.code.toUpperCase() === AV_CASCATA.cupao.toUpperCase() && d.applicable;
      });

      cart.items.forEach(function (item) {
        var links = qsaDeep('a[href*="variant=' + item.variant_id + '"]');
        if (!links.length) return;

        links.forEach(function (link) {
          var row = link.closest('li, tr, [class*="item" i]') || link.parentElement;
          var sobe = 0;
          while (row && sobe < 4 && !/\d,\d\d/.test(row.textContent)) { row = row.parentElement; sobe++; }
          if (!row) return;

          // o bloco AV_CASCATA já criou este span com o preço de linha correto;
          // se ainda não existir, esta linha ainda não foi processada — tenta no próximo ciclo
          var precoSpan = row.querySelector('.av-cart-preco');
          if (!precoSpan) return;

          var iconWrap = row.querySelector('.av-info-wrap');
          if (!iconWrap) {
            iconWrap = document.createElement('span');
            iconWrap.className = 'av-info-wrap';
            estilizarWrap(iconWrap);

            var botao = document.createElement('button');
            botao.type = 'button';
            botao.className = 'av-info-icon';
            botao.setAttribute('aria-label', 'Como funciona este preço');
            botao.textContent = 'i';
            estilizarIcone(botao);

            var tooltip = document.createElement('div');
            tooltip.className = 'av-tooltip';
            estilizarTooltip(tooltip);

            iconWrap.appendChild(botao);
            iconWrap.appendChild(tooltip);

            ligarBotao(botao, tooltip);       // clique ligado diretamente ao botão
            tooltipsCriados.push(tooltip);    // registo p/ fecharTodos() (atravessa shadow DOM)

            var precoRiscado = row.querySelector('s, del');
            var alvo = precoRiscado || precoSpan;
            alvo.parentNode.insertBefore(iconWrap, alvo);
          }

          var minimo = precoMinimo(item.original_price);
          var texto = textoPopover(cart.item_count, minimo, cupaoAplicado);
          var tipEl = iconWrap.querySelector('.av-tooltip');
          if (tipEl.innerHTML !== texto) tipEl.innerHTML = texto;
        });
      });
    }).catch(function (e) { if (AV_CASCATA.debug) console.warn('[av-tooltip-cart] /cart.js falhou', e); });
  }

  function correr() {
    try { initListener(); processarCarrinho(); }
    catch (e) { console.warn('[av-tooltip-cart]', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }

  var avTimer2;
  new MutationObserver(function () {
    clearTimeout(avTimer2);
    avTimer2 = setTimeout(correr, 250);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  setInterval(correr, 1500);
})();